// let hasExtensionInstalled = false;
// if ($(window).width() >= 767) {
// fetch("chrome-extension://mjgpadhbdcnenmggkfnplobggckadhco/options.html").then(
fetch("chrome-extension://aliibphiifpfbmbhabmoaglndakcigdm/options.html").then(
  (r) => {
    if (r) {
      window.hasExtensionInstalled = true;
    }
  }
);
// }

// if (hasExtensionInstalled) {
//   alert();
// }

// var frumShopperLinks=[...document.getElementsByClassName('frum-shopper-product-link')];
function getRefbyVal(tags) {
  if (tags) {
    const tagsArr = tags.split(",");
    return (tagsArr.filter((t) => t.startsWith("refby:"))[0] || "").replace(
      "refby:",
      ""
    );
  }
}
function formatAmLink(link) {
  const twoParts = link?.split("?");
  // if (!twoParts || twoParts.length === 1) {
  //   return link;
  // }
  const urlParams = new URLSearchParams(twoParts.length > 1 ? twoParts[1] : "");
  const tag = urlParams.get("tag");
  urlParams.delete("tag");
  urlParams.set("tag", "vin049-20");
  return twoParts[0] + "?" + urlParams.toString();
}
document.addEventListener("DOMContentLoaded", function (event) {
  // alert();
  var frumShopperLinks = document.getElementsByClassName(
    "frum-shopper-product-link"
  );
  var outLinks = document.getElementsByClassName("out-link");
  // console.log("outlinks", outLinks);
  // with this function, we add a parameter so the extension can know if should offer to edit a product from the product on the retailer's site rather than add it (a shortcut to editing/deleting products)
  formatActualUrl = function (
    url,
    hasExtensionInstalled,
    product,
    shouldEncodeChar
  ) {
    if (!hasExtensionInstalled) {
      return url;
    }

    const hashArr = url.split("#");

    const charToPrep =
      hashArr[0].indexOf("?") > -1
        ? shouldEncodeChar
          ? "%26"
          : "&"
        : shouldEncodeChar
        ? "%3F"
        : "?";
    const andChar = shouldEncodeChar ? "%26" : "&";
    hashArr[0] =
      hashArr[0] +
      charToPrep +
      "tfsitem=" +
      product.id +
      andChar +
      "tfsOrigPrice=" +
      product.variants[0].price;
    return hashArr.join("#");
  };

  window.doPost = (e) => {
    console.log("hi", e);

    // var link = e.target;
    const url = e
      .closest(".grid__item")
      .querySelector(".tiacd-product-link").href;
    const price = e
      .closest(".grid__item")
      .querySelector(".price-item.price-item--regular")
      ?.textContent?.trim();
    const store = e
      .closest(".grid__item")
      .querySelector(".caption-with-letter-spacing.light")
      ?.textContent?.trim()
      ?.replace(/&/g, "%26");
    const imgUrl = e
      .closest(".grid__item")
      .querySelector(".card__media img").src;

    console.log(e.closest("div").querySelector("textarea").value);
    fetch(
      "https://k284cusybk.execute-api.us-east-1.amazonaws.com/Prod/api/Shopify/post-what?token=test" +
        "&text=" +
        e
          .closest("div")
          .querySelector("textarea")
          .value.replace(/\r?\n/g, "<br />") +
        "&imgUrl=" +
        imgUrl
    ).then((r) => {
      if (r.ok) {
        // alert("Success!!!");
        e.closest(".appended-post-div").remove();
      } else {
        alert("Failed :(");
      }
    });
  };

  const vlinks=['Nordstrom Rack'];
  // const vlinks=[];

  // function postW(url,price,store){
  function postW(e) {
    console.log(e);
    var link = e.target;
    const outLink = link.closest(".grid__item").querySelector(".out-link");
    const vendor = outLink.attributes["data-vendor"].textContent;
    let url = "";
    const isVlink = vlinks.indexOf(vendor) > -1;
    let slink = link
      .closest(".grid__item")
      .querySelector(".out-link")
      .getAttribute(isVlink ? "vlink" : "slink");
    if(isVlink){
      slink = slink.replace('ad2a5b5880e0658f909c1e683ff350f5', '5341d5b4efc88776c7de91e74678b1ef');
    }
    console.log("slink", slink);
    if (slink) {
      url =
        slink.replace(/&/g, "%26").replace("243977X1727417", "99551X1634963")
        // +
        // "%26utm_source=newhatsapp"
      ;
      
    } else {
      url = link
        .closest(".grid__item")
        .querySelector(".tiacd-product-link").href;
    }
    // if(vendor === "Amazon"){
    //   url=link.closest(".grid__item").querySelector(".tiacd-product-link").href;
    // }else if(link.getAttribute)
    // const url =
    //   vendor === "Amazon"
    //     ? link.closest(".grid__item").querySelector(".tiacd-product-link").href
    //     : outLink.href
    //         .replace(/&/g, "%26")
    //         .replace("243977X1727417", "99551X1634963") +
    //       "%26utm_source=newhatsapp";

    const price = link
      .closest(".grid__item")
      .querySelector(".price-item.price-item--regular")
      ?.textContent?.trim();
    const store = link
      .closest(".grid__item")
      .querySelector(".caption-with-letter-spacing.light")
      ?.textContent?.trim()
      .replace(/&/g, "%26");
    const title = link
      .closest(".grid__item")
      .querySelector("a.out-link")
      ?.textContent?.trim()
      .replace(/&/g, "and");
    const myalert = () => alert();
    e.target.closest(".grid__item").innerHTML +=
      '<div style="position:relative;z-index:9999999999;" class="appended-post-div"><div style="position:absolute;white-space:pre-wrap;"><textarea style="height:250px;">' +
      
            (title.length > 50 ? title.substring(0,50).trim() + "..." : title) +
      "\n" +
      price +
      "\n\n" +

      store +
      "\n\n" +
      url +
      '</textarea><br/><button onclick="doPost(this)">Post</button></div></div>';
    // window.open(
    //   "https://api.whatsapp.com/send?phone=13472803050&text=" + store + "%0D%0A%0D%0A" + price + "%0D%0A%0D%0A" + url, '_blank');

    // fetch(
    //   "https://k284cusybk.execute-api.us-east-1.amazonaws.com/Prod/api/Shopify/post-what?token=test&url=" +
    //     link.closest(".grid__item").querySelector(".tiacd-product-link").href +
    //     "&price=" +
    //     link
    //       .closest(".grid__item")
    //       .querySelector(".price-item.price-item--regular")
    //       ?.textContent?.trim() +
    //     "&store=" +
    //     link
    //       .closest(".grid__item")
    //       .querySelector(".caption-with-letter-spacing.light")
    //       ?.textContent?.trim()
    // ).then((r) => {
    //   if (r.ok) {
    //     alert("Success!!!");
    //   } else {
    //     alert("Failed :(");
    //   }
    // });
  }
  const mainUrlParams = new URLSearchParams(window.location.search);
  const showWhats = mainUrlParams.get("showpostingon");

  [...(outLinks || [])].map(function (link) {
    if (window.hasExtensionInstalled || showWhats) {
      const node = document.createElement("span");
      const textnode = document.createTextNode("Post on WhatsApp");
      node.appendChild(textnode);
      // node.target = "_blank";
      node.onclick = postW;

      // node.href =
      //   "https://k284cusybk.execute-api.us-east-1.amazonaws.com/Prod/api/Shopify/post-what?token=test&url=" +
      //     // link.href +
      //   link.closest('.grid__item').querySelector('.tiacd-product-link').href +
      //    "&price=" +
      //     link.closest(".grid__item").querySelector('.price-item.price-item--regular')?.textContent?.trim() +
      //     "&store=" +
      //     link.closest(".grid__item").querySelector('.caption-with-letter-spacing.light')?.textContent?.trim();
      node.style.position = "absolute";
      node.style["z-index"] = 999999;
      node.style["cursor"] = "pointer";
      node.style["color"] = "blue";
      link.closest(".grid__item").appendChild(node);
    }
    // link.href = getFrumShopperLink(
    //   link.href,
    //   getRefbyVal(link.attributes["refby"].textContent)
    // );
    setFrumShopperLink(link);
  });

  function getFrumShopperLink(url, productReferrer) {
    const hasExtensionInstalled = false;
    const product = null;

    // let productReferrer = null;
    // let priceUpBy = null;

    let custId = "";
    if (productReferrer) {
      custId += "refid-" + productReferrer;
    }
    const amznReferrersList = [
      // "zbe",
      // "cht",
      // "tls",
      // "ahz",
      "etgo",
      // "besm",
      // "moei",
      // "jula",
      // "nbt",
      "simi",
      // "yaz",
      // "csz",
      // "sy",
      // "min",
      // "blz",
      // "mws",
      // "atk",
      // "pln",
      // "sarit",
      // "abbyem",
      // "tzvih",
      // "ykohrreuvein",
      // "chayasora",
      // "devorasp",
      // "hhgg",
      // "yachet",
      // "letsartit",
      "suriy",
      // "yaakovt",
      // "hessfr",
      "srulyw",
      "perelt",
      "goldyf",
      "chaniek",
      // "shaindyg",
      // "tovas",
      // "judy",
      "malkar",
      // "delem",
      "rachelf",
      // "sorakr",
    ];

    let linkToReturn = "";
    if (
      //   url.includes("ugg.com") ||
      //   url.includes("talbots.com") ||
      //   url.includes("jcpenney.com") ||
      //   url.includes("tjx.com") ||
      //   url.includes("marshalls.com") ||
      //   url.includes("gilt.com") ||
      //   // ||url.includes('nordstromrack.com')
      //   // // ||url.includes('nordstrom.com')
      //   url.includes("saksoff5th.com") ||
      //   url.includes("saksfifthavenue.com") ||
      //   // ||url.includes('macys.com')
      //   url.includes("bloomingdales.com") ||
      //   url.includes("asos.com") ||
      //   url.includes("shein.com") ||
      //   url.includes("anntaylor.com") ||
      //   url.includes("walmart.com") ||
      //   url.includes("yoox.com") ||
      //   url.includes("zappos.com") ||
      //   url.includes("toryburch.com") ||
      //   url.includes("sierra.com") ||
      //   url.includes("gap.com") ||
      //   url.includes("aliexpress.com") ||
      //   url.includes("aliexpress.us") ||
      //   url.includes("hardtailforever.com") ||
      //   url.includes("zulily.com") ||
      //   url.includes("theoutnet.com") ||
      //   url.includes("lordandtaylor.com") ||
      //   url.includes("dsw.com") ||
      //   url.includes("gapfactory.com") ||
      //   url.includes("tedbaker.com") ||
      //   url.includes("mango.com") ||
      //   url.includes("karenmillen.com") ||
      //   url.includes("uniqlo.com") ||
      //   url.includes("cettire.com") ||
      //   url.includes("johnnywas.com") ||
      //   url.includes("mytheresa.com")
      // ) {
      //   //   return `https://go.skimresources.com?${custId?'xcust='+custId +'&':''}id=230449X1712831&xs=1&url=${url}`;
      //   linkToReturn =
      //     "https://go.skimresources.com?" +
      //     (custId ? "xcust=" + custId + "&" : "") +
      //     "id=230449X1712831&xs=1&url=" +
      //     formatActualUrl(url, hasExtensionInstalled, product);
      // } else if (
      url.includes(
        "bananarepublicfactory.gapfactory.com/browse/product.do?vid=1&pid=7137480110000"
      )
    ) {
      return url;
    } else if (url.includes("target.com")) {
      //   return `https://goto.target.com/c/325851/520943/2092?${sharlinksId?'subId1=adid'+sharlinksId +'&':''}${productReferrer?'subId2=refid'+productReferrer +'&':''}u=${url}`;
      linkToReturn =
        "https://goto.target.com/c/325851/520943/2092?" +
        // (sharlinksId ? "subId1=adid" + sharlinksId + "&" : "") +
        (productReferrer ? "subId2=refid" + productReferrer + "&" : "") +
        "u=" +
        formatActualUrl(url, hasExtensionInstalled, product);
    } else if (
      url.includes("theshellstation.com") ||
      url.includes("apparalel.com") ||
      url.includes("junees.com") ||
      url.includes("tottini.com")
    ) {
      const stName = url.includes("theshellstation.com")
        ? "theshellstation"
        : url.includes("apparalel.com")
        ? "apparalel"
        : url.includes("junees.com")
        ? "junees"
        : url.includes("tottini.com")
        ? "tottini"
        : "nostore";
      const firstPartOfLink = formatActualUrl(
        url,
        hasExtensionInstalled,
        product
      );
      const joinChar = firstPartOfLink.indexOf("?") > -1 ? "&" : "?";
      linkToReturn =
        firstPartOfLink +
        joinChar +
        "aff=3&utm_source=frumshopper&utm_medium=affiliate&utm_campaign=regular&utm_term=" +
        // (sharlinksId ? sharlinksId : "none") +
        "&utm_content=" +
        (productReferrer ? productReferrer : "none") +
        '" onClick="frumShopperRecordClick({store:\'' +
        stName +
        "',refid:'" +
        productReferrer +
        // "',adid:'" +
        // sharlinksId +
        "',link:'" +
        formatActualUrl(url, hasExtensionInstalled, product) +
        "'})";
    } else if (
      url.includes("ybgiftshop.com") ||
      url.includes("https://yarmulkesandbows.com")
    ) {
      const joinChar = url.indexOf("?") > -1 ? "&" : "?";
      linkToReturn = url + "?bg_ref=1859:4Bs0UouDUd";
    } else if (!url.includes("amazon.com")) {
      // linkToReturn =
      //   "https://redirect.viglink.com?" +
      //   (custId ? "cuid=" + custId + "&" : "") +
      //   "key=2e5e3d62649c379052dd1e4f846b96aa&u=" +
      //   formatActualUrl(url, hasExtensionInstalled, product, true);

      // // setting to skimlinks as viglink is not for now
      linkToReturn =
        "https://go.skimresources.com?" +
        (custId ? "xcust=" + custId + "&" : "") +
        // "id=230449X1712831&xs=1&url=" +
        "id=99551X1634963&xs=1&url=" +
        formatActualUrl(url, hasExtensionInstalled, product);

      // } else if (
      //   sharlinksId &&
      //   amznReferrersList.filter(function (r) {
      //     return r === sharlinksId;
      //   }).length
      // ) {
      //   //     const toRepla = productReferrer === 'ykohrreuvein' ? productReferrer : sharlinksId;
      //   const toRepla = isReferralInOverridesList ? productReferrer : sharlinksId;
      //   linkToReturn = formatActualUrl(
      //     url,
      //     hasExtensionInstalled,
      //     product
      //     // ).replace("thefrumshoppe", "thefrumshop-" + toRepla);
      //   ).replace("thefrumshoppe", "");
    } else if (
      productReferrer &&
      amznReferrersList.filter(function (r) {
        return r === productReferrer;
      }).length
    ) {
      const u = formatAmLink(url);
      // const u = url;
      linkToReturn = formatActualUrl(
        u,
        hasExtensionInstalled,
        product
        // ).replace("thefrumshoppe", "thefrumshop-" + productReferrer);
      ).replace("vin049", "vin" + productReferrer + "049");
    } else {
      linkToReturn = url;
    }

    // return linkToReturn;
    // const u=formatAmLink(linkToReturn);
    const u = linkToReturn;

    // return u.replace("thefrumshoppe", "tiacd");
    return u;
  }

  function setFrumShopperLink(link) {
    const url = link.href;
    const productReferrer = getRefbyVal(link.attributes["refby"]?.textContent || '');
    const hasExtensionInstalled = false;
    const product = null;

    // let productReferrer = null;
    // let priceUpBy = null;

    let custId = "";
    if (productReferrer) {
      custId += "refid-" + productReferrer;
    }
    const amznReferrersList = [
      // "zbe",
      // "cht",
      // "tls",
      // "ahz",
      "etgo",
      // "besm",
      // "moei",
      // "jula",
      // "nbt",
      "simi",
      // "yaz",
      // "csz",
      // "sy",
      // "min",
      // "blz",
      // "mws",
      // "atk",
      // "pln",
      // "sarit",
      // "abbyem",
      // "tzvih",
      // "ykohrreuvein",
      // "chayasora",
      // "devorasp",
      // "hhgg",
      // "yachet",
      // "letsartit",
      "suriy",
      // "yaakovt",
      // "hessfr",
      "srulyw",
      // "perelt",
      "goldyf",
      "chaniek",
      // "shaindyg",
      // "tovas",
      // "judy",
      "malkar",
      // "delem",
      // "rachelf",
      // "sorakr",
    ];

    let linkToReturn = "";
    if (
      //   url.includes("ugg.com") ||
      //   url.includes("talbots.com") ||
      //   url.includes("jcpenney.com") ||
      //   url.includes("tjx.com") ||
      //   url.includes("marshalls.com") ||
      //   url.includes("gilt.com") ||
      //   // ||url.includes('nordstromrack.com')
      //   // // ||url.includes('nordstrom.com')
      //   url.includes("saksoff5th.com") ||
      //   url.includes("saksfifthavenue.com") ||
      //   // ||url.includes('macys.com')
      //   url.includes("bloomingdales.com") ||
      //   url.includes("asos.com") ||
      //   url.includes("shein.com") ||
      //   url.includes("anntaylor.com") ||
      //   url.includes("walmart.com") ||
      //   url.includes("yoox.com") ||
      //   url.includes("zappos.com") ||
      //   url.includes("toryburch.com") ||
      //   url.includes("sierra.com") ||
      //   url.includes("gap.com") ||
      //   url.includes("aliexpress.com") ||
      //   url.includes("aliexpress.us") ||
      //   url.includes("hardtailforever.com") ||
      //   url.includes("zulily.com") ||
      //   url.includes("theoutnet.com") ||
      //   url.includes("lordandtaylor.com") ||
      //   url.includes("dsw.com") ||
      //   url.includes("gapfactory.com") ||
      //   url.includes("tedbaker.com") ||
      //   url.includes("mango.com") ||
      //   url.includes("karenmillen.com") ||
      //   url.includes("uniqlo.com") ||
      //   url.includes("cettire.com") ||
      //   url.includes("johnnywas.com") ||
      //   url.includes("mytheresa.com")
      // ) {
      //   //   return `https://go.skimresources.com?${custId?'xcust='+custId +'&':''}id=230449X1712831&xs=1&url=${url}`;
      //   linkToReturn =
      //     "https://go.skimresources.com?" +
      //     (custId ? "xcust=" + custId + "&" : "") +
      //     "id=230449X1712831&xs=1&url=" +
      //     formatActualUrl(url, hasExtensionInstalled, product);
      // } else if (
      url.includes(
        "bananarepublicfactory.gapfactory.com/browse/product.do?vid=1&pid=7137480110000"
      )
    ) {
      return url;
    } else if (url.includes("target.com")) {
      //   return `https://goto.target.com/c/325851/520943/2092?${sharlinksId?'subId1=adid'+sharlinksId +'&':''}${productReferrer?'subId2=refid'+productReferrer +'&':''}u=${url}`;
      linkToReturn =
        "https://goto.target.com/c/325851/520943/2092?" +
        // (sharlinksId ? "subId1=adid" + sharlinksId + "&" : "") +
        (productReferrer ? "subId2=refid" + productReferrer + "&" : "") +
        "u=" +
        formatActualUrl(url, hasExtensionInstalled, product);
    } else if (
      url.includes("theshellstation.com") ||
      url.includes("apparalel.com") ||
      url.includes("junees.com") ||
      url.includes("tottini.com")
    ) {
      const stName = url.includes("theshellstation.com")
        ? "theshellstation"
        : url.includes("apparalel.com")
        ? "apparalel"
        : url.includes("junees.com")
        ? "junees"
        : url.includes("tottini.com")
        ? "tottini"
        : "nostore";
      const firstPartOfLink = formatActualUrl(
        url,
        hasExtensionInstalled,
        product
      );
      const joinChar = firstPartOfLink.indexOf("?") > -1 ? "&" : "?";
      linkToReturn =
        firstPartOfLink +
        joinChar +
        "aff=3&utm_source=frumshopper&utm_medium=affiliate&utm_campaign=regular&utm_term=" +
        // (sharlinksId ? sharlinksId : "none") +
        "&utm_content=" +
        (productReferrer ? productReferrer : "none") +
        '" onClick="frumShopperRecordClick({store:\'' +
        stName +
        "',refid:'" +
        productReferrer +
        // "',adid:'" +
        // sharlinksId +
        "',link:'" +
        formatActualUrl(url, hasExtensionInstalled, product) +
        "'})";
    } else if (
      url.includes("ybgiftshop.com") ||
      url.includes("https://yarmulkesandbows.com")
    ) {
      const joinChar = url.indexOf("?") > -1 ? "&" : "?";
      linkToReturn = url + "?bg_ref=1859:4Bs0UouDUd";
    } else if (!url.includes("amazon.com")) {
      // linkToReturn =
      //   "https://redirect.viglink.com?" +
      //   (custId ? "cuid=" + custId + "&" : "") +
      //   // "key=2e5e3d62649c379052dd1e4f846b96aa&u=" +
      //   "key=ad2a5b5880e0658f909c1e683ff350f5&u=" +
      //   formatActualUrl(url, hasExtensionInstalled, product, true);

      // setting to skimlinks as viglink is not for now
      linkToReturn =
        "https://go.skimresources.com?" +
        (custId ? "xcust=" + custId + "&" : "") +
        // "id=230449X1712831&xs=1&url=" +
        "id=99551X1634963&xs=1&url=" +
        formatActualUrl(url, hasExtensionInstalled, product);
      link.setAttribute(
        "slink",
        "https://go.skimresources.com?" +
          (custId ? "xcust=" + custId + "&" : "") +
          // "id=230449X1712831&xs=1&utm_source=newhatsapp&url=" +
          "id=99551X1634963&xs=1&utm_source=newhatsapp&url=" +
          formatActualUrl(url, hasExtensionInstalled, product)
      );
      link.setAttribute(
        "vlink",
        "https://redirect.viglink.com?" +
          (custId ? "cuid=" + custId + "&" : "") +
          "key=ad2a5b5880e0658f909c1e683ff350f5&u=" +
          formatActualUrl(url, hasExtensionInstalled, product, true)
      );

      // } else if (
      //   sharlinksId &&
      //   amznReferrersList.filter(function (r) {
      //     return r === sharlinksId;
      //   }).length
      // ) {
      //   //     const toRepla = productReferrer === 'ykohrreuvein' ? productReferrer : sharlinksId;
      //   const toRepla = isReferralInOverridesList ? productReferrer : sharlinksId;
      //   linkToReturn = formatActualUrl(
      //     url,
      //     hasExtensionInstalled,
      //     product
      //     // ).replace("thefrumshoppe", "thefrumshop-" + toRepla);
      //   ).replace("thefrumshoppe", "");
    } else if (
      productReferrer &&
      amznReferrersList.filter(function (r) {
        return r === productReferrer;
      }).length
    ) {
      const u = formatAmLink(url);
      // const u = url;
      linkToReturn = formatActualUrl(
        u,
        hasExtensionInstalled,
        product
        // ).replace("thefrumshoppe", "thefrumshop-" + productReferrer);
      ).replace("vin049", "vin" + productReferrer + "049");
    } else {
      linkToReturn = url;
    }

    // return linkToReturn;
    // const u=formatAmLink(linkToReturn);
    const u = linkToReturn;

    // return u.replace("thefrumshoppe", "tiacd");
    // return u;
    link.href = u;
    // link['data-hello']= 'hi there';
    // link.setAttribute('new','hello');
  }
});
